/** @format — Open Paystack modal from AG-UI payment_event */

import { paymentEvents } from "../../utils/paymentEvents";
import {
  isOpenPaymentModalEvent,
  normalizePaymentPayload,
} from "../../utils/paymentPayload";

export function openPaymentFromStreamEvent(paymentEvent, user) {
  if (!isOpenPaymentModalEvent(paymentEvent)) return false;
  paymentEvents.openPaymentModal(normalizePaymentPayload(paymentEvent, user));
  return true;
}
